import React from 'react'


const ArrowBackward = ({ className }) => {
    return (
      <svg
        width="10"
        height="16"
        viewBox="0 0 10 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0.9427 8.97676C0.727099 8.75798 0.605982 8.46129 0.605982 8.15193C0.605982 7.84257 0.727099 7.54588 0.9427 7.3271L7.44852 0.727264C7.55461 0.615835 7.68151 0.526956 7.82182 0.465812C7.96213 0.404668 8.11304 0.372484 8.26574 0.371138C8.41844 0.369792 8.56988 0.399311 8.71122 0.457972C8.85255 0.516633 8.98096 0.603261 9.08894 0.712803C9.19692 0.822344 9.28232 0.952605 9.34014 1.09598C9.39797 1.23936 9.42706 1.39299 9.42574 1.5479C9.42441 1.70281 9.39269 1.8559 9.33241 1.99824C9.27214 2.14057 9.18453 2.26931 9.07469 2.37693L3.38195 8.15193L9.07469 13.9269C9.28418 14.147 9.40009 14.4417 9.39747 14.7476C9.39485 15.0535 9.2739 15.3461 9.06068 15.5624C8.84745 15.7787 8.559 15.9014 8.25746 15.9041C7.95592 15.9067 7.66542 15.7891 7.44852 15.5766L0.9427 8.97676Z"
          fill="#DE4AC4"
        />
      </svg>
    );
  };

export default ArrowBackward